import board from '@/app/board/shared/store/board'
import card from '@/app/board/shared/store/card'
import listDragdrop from '@/app/board/shared/store/list-dragdrop'
import listFilter from '@/app/board/shared/store/list-filter'
import history from '@/app/board/shared/store/history'
import tag from '@/app/board/shared/store/tag'
import note from '@/app/board/shared/store/note'
import timerTracking from '@/app/board/shared/store/timer-tracking'

export default {
  board,
  card,
  listDragdrop,
  listFilter,
  history,
  note,
  tag,
  timerTracking
}
